module.exports = __webpack_public_path__ + "static/media/lucionBg.3c4faf0a.png";